import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import AuthModal from './AuthModal';

const RegisterPage = () => {
  const location = useLocation();
  const preFilledData = location.state?.preFilledData;
  
  return (
    <div className="min-h-screen bg-gray-50">
      <AuthModal 
        isOpen={true} 
        onClose={() => {}} 
        defaultTab="signup"
        preFilledData={preFilledData}
      />
    </div>
  );
};

export default RegisterPage;
